import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/features/auth/data-access/auth.service';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';

const shouldSkipAuthHeader = (req: HttpRequest<any>) => {
  const url = req.url;
  return url.includes('/auth/login') || url.includes('/auth/refresh');
};

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  let cloned = req;

  const token = auth.token;
  if (token && !shouldSkipAuthHeader(req)) {
    cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(cloned).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !shouldSkipAuthHeader(req)) {
        // Attempt token refresh
        return auth.refreshToken().pipe(
          switchMap((tokens) => {
            if (!tokens) {
              // Si no hay tokens, la sesión fue revocada - redirigir a login
              router.navigate(['/login'], { 
                queryParams: { 
                  reason: 'session_revoked',
                  message: 'Tu sesión fue cerrada porque iniciaste sesión desde otro dispositivo.'
                } 
              });
              return throwError(() => error);
            }
            const retry = req.clone({
              setHeaders: {
                Authorization: `Bearer ${tokens.access_token}`,
              },
            });
            return next(retry);
          }),
          catchError((err) => {
            // Si el refresh falla, la sesión fue revocada - redirigir a login
            router.navigate(['/login'], { 
              queryParams: { 
                reason: 'session_revoked',
                message: 'Tu sesión fue cerrada porque iniciaste sesión desde otro dispositivo.'
              } 
            });
            return throwError(() => err);
          })
        );
      }
      return throwError(() => error);
    })
  );
};

